import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { setFilter } from "home/actions"

const Filter = ({ caption, name, options, dispatch, filters }) => (
  <div className="filter">
    <label>{caption}</label>
    <select onChange={e => dispatch(setFilter({ [name]: e.target.value }))} value={filters[name]}>
      {options.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
)

Filter.propTypes = {
  name: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  options: PropTypes.array
}

const mapStateToProps = state => {
  return {
    filters: state.filters
  }
}

export default connect(mapStateToProps)(Filter)
